import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  actionContainer: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
  },
}));

const ActionContainer: FC = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.actionContainer}>{children}</div>;
};

export default ActionContainer;
